import type { ApiConfig } from '../../types'

export const spotTaxHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 500,
  order: 'asc',
  range: 30 * 24 * 60 * 60 * 1000, // 30 days in milliseconds
  requiresRange: true,
  type: 'spot-tax-history',
} as const satisfies ApiConfig
